import React from 'react';
import { useDispatch } from 'react-redux';
import { INSTALLATION_ADDRESS } from '@/constants/installationAddress';
import RadioButtonController from '@/components/radioButtonController';
import { LABEL_SIZE, LABEL_COLOR } from '@/components/radioButton';
import FormTemplate, { THEMES } from '@/components/formTemplate';
import Text, { TEXT_COLOR, TEXT_SIZE } from '@/bit/components/components.text';
import { actions as addressActions } from '@/reducers/address-reducer';

function ChoosePersonalData({
  control,
  addresses,
  addressSelected,
  addressAction = null,
  getValues,
}) {
  const dispatch = useDispatch();
  const { TITLE, ID, CLIENT_ADDRESSES } = INSTALLATION_ADDRESS;
  return (
    <>
      <div className="choose-client-addresses-container">
        <FormTemplate titleText={TITLE} cyData={ID} theme={THEMES.LONG}>
          <div className="choose-client-addresses__text">
            <Text
              text="Inidica en que dirección quieres aplicar el cambio de configuración"
              size={TEXT_SIZE.CAPTION2}
              color={TEXT_COLOR.GREY4}
              cyData={`${ID}__au_text`}
            />
          </div>

          <RadioButtonController
            inputName={CLIENT_ADDRESSES.NAME}
            inputId={CLIENT_ADDRESSES.ID}
            control={control}
            rules={{
              required: CLIENT_ADDRESSES.RULES.REQUIRED,
            }}
            label={CLIENT_ADDRESSES.LABEL}
            options={addresses}
            withBox={false}
            withCheck
            column
            defaultValue={{ value: addressSelected?.value }}
            handleOnChange={({ value }) => {
              if (addressAction) {
                const addressSelectedInfo = addresses.find(
                  (item) => item?.value === value?.value
                );
                const { lineCoverage } = { ...addressSelectedInfo };
                const { ftthCoverage: coverage } = { ...lineCoverage };
                dispatch(addressActions.setCoverage({ coverage }));
                dispatch(addressAction({ formData: getValues() }));
              }
            }}
            labelSize={LABEL_SIZE.CAPTION1}
            labelColor={LABEL_COLOR.GREY5}
          />
        </FormTemplate>
      </div>

      <style jsx>
        {`
          .choose-client-addresses-container {
            position: relative;
            display: flex;
            flex-direction: column;
            padding-bottom: 12px;
            .choose-client-addresses-container--row {
              max-width: 100%;
              display: flex;
              flex-direction: row;
              justify-content: space-between;
            }
            .choose-client-addresses__text {
              margin-bottom: 8px;
            }
          }
        `}
      </style>
    </>
  );
}
export default ChoosePersonalData;
